export default __webpack_public_path__ + "static/media/i94ol-min.e29f0627.png";